import withAemIntegration from "../../withAemIntegration";
import loadable from "../../utils/loadable";
const Component = loadable(() =>
  import("@lexus.com/ui/dist/components/PromoModule")
);

const PromoModuleEditConfig = {
  emptyLabel: "PromoModule",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const transformData = (props) => ({
  component: "Promo Module",
  props: {
    ...props,
    contentTitle: props.title,
  },
});

const PromoModule = (props) => {
  const data = transformData(props);
  return (
    <Component
      {...data.props}
      height={window && window.CQ ? "auto" : undefined}
    />
  );
};

export default withAemIntegration("lexus/components/promo-module")(
  PromoModule,
  PromoModuleEditConfig
);
